import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

import { getInputStateType } from '../../../../forms/Input/getInputStateType';

export const StyledCharCounter = styled('span', { shouldForwardProp })(
  (props) => {
    const type = getInputStateType(props);
    return css({
      position: 'absolute',
      zIndex: 'popup',
      paddingTop: '1x_small',
      fontSize: `input.${props.shrink ? 'shrink' : 'label'}`,
      color: `input.${type}.label`,
      lineHeight: 'input',
      fontFamily: 'body',
      background: 'none',
    });
  }
);

const CharCounter = ({ maxLength, value = '', ...rest }) => {
  return (
    <StyledCharCounter {...rest}>
      {value.length}/{maxLength}
    </StyledCharCounter>
  );
};
export default CharCounter;
